import React from "react";
import "./styles/global.scss"; // Import your global styles here
import AppRouter from "./routes/AppRouter";
import { ModalProvider } from "./context/ModalContext";
import { Suspense } from "react";
import { I18nextProvider } from "react-i18next";
import i18n from "./i18n";
import { GoogleOAuthProvider } from "@react-oauth/google";
import { ToastContainer } from "react-toastify";
import "react-toastify/dist/ReactToastify.css";
import { SocialLoginProvider } from "./context/SocialLoginConnect";

function App() {
  return (
    <GoogleOAuthProvider clientId="245123695626-qj6qqme1sbfm0mtvq24fbj4e86943brb.apps.googleusercontent.com">
      <I18nextProvider i18n={i18n}>
        <Suspense fallback={<div>Loading...</div>}>
          <ModalProvider>
            <ToastContainer />
            <SocialLoginProvider>
            <div className="bg-white dark:bg-black">
              <AppRouter />
            </div>
            </SocialLoginProvider>
          </ModalProvider>
        </Suspense>
      </I18nextProvider>
    </GoogleOAuthProvider>
  );
}

export default App;
